<template>
  <el-dialog
    v-model="visible"
    width="600px"
    @close="handleClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="select-enterprise-dialog"
  >
    <template #header>
      <span class="font-semibold">选择代投保企业</span>
    </template>

    <div class="search-section">
      <div class="search-input-group">
        <span class="label required">企业名称</span>
        <el-input
          v-model="searchValue"
          placeholder="请输入企业名称"
          class="search-input"
          @keyup.enter="handleSearch"
        />
        <el-button
          type="primary"
          @click="handleSearch"
          class="search-btn"
          :loading="loading"
        >
          查询
        </el-button>
      </div>
    </div>

    <div class="table-section">
      <el-table :data="tableData" style="width: 100%" v-loading="loading">
        <el-table-column label="企业信息" min-width="300">
          <template #default="scope">
            <div class="company-info">
              <div class="info-row">
                <span class="label">企业名称：</span>
                <span class="value">{{ scope.row.enterpriseName }}</span>
              </div>
              <div class="info-row" v-if="scope.row.enterpriseState">
                <span class="label">企业状态：</span>
                <span class="value">{{
                  scope.row.enterpriseState === 0 ? '开通' : '停用'
                }}</span>
              </div>
              <div class="info-row" v-if="scope.row.openUserAccount">
                <span class="label">开通人账号：</span>
                <span class="value">{{ scope.row.openUserAccount }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template #default="scope">
            <el-button
              type="primary"
              size="small"
              @click="handleSelect(scope.row)"
              text
            >
              选择
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { fetchProxyEnterpriseList } from '@/api/hgj'
import { ElMessage } from '@hgj/element-plus'
import { useAuthStore } from '@/store/authStore'

const authStore = useAuthStore()

defineOptions({
  name: 'SelectEnterpriseDialog',
})

const visible = ref(true)
const searchValue = ref('')
const emits = defineEmits(['resolve', 'reject'])
const tableData = ref<any[]>([])
const loading = ref(false)

const handleClose = () => {
  emits('reject')
}

const handleSearch = async () => {
  if (!searchValue.value?.trim()) {
    return ElMessage.error('请输入企业名称')
  }

  loading.value = true
  try {
    const [err, res] = await fetchProxyEnterpriseList({
      keyword: searchValue.value.trim(),
    })

    if (err || !res?.success) {
      return
    }

    tableData.value = res.data || []

    if (tableData.value.length === 0) {
      ElMessage.warning('未查询到符合条件的企业')
    }
  } catch (error) {
    console.error('查询企业列表失败:', error)
  } finally {
    loading.value = false
  }
}

const handleSelect = (row: any) => {
  emits('resolve', {
    id: row.enterpriseId,
    name: row.enterpriseName,
    openUserAccount: row.openUserAccount,
    enterpriseState: row.enterpriseState,
    poroxyEnterpriseId: authStore.userInfo?.enterpriseId,
  })
}
</script>

<style lang="scss" scoped>
.search-section {
  margin-bottom: 20px;

  .search-input-group {
    display: flex;
    align-items: center;
    gap: 8px;

    .label {
      color: #333;
      white-space: nowrap;

      &.required::before {
        content: '*';
        color: #f56c6c;
        margin-right: 4px;
      }
    }

    .search-input {
      flex: 1;
      max-width: 400px;
    }

    .search-btn {
      width: 80px;
    }
  }
}

.table-section {
  padding-bottom: 20px;
  max-height: 400px;
  overflow-y: auto;

  .el-table {
    border: 1px solid #ebeef5;
  }
}

.company-info {
  padding: 8px 0;

  .info-row {
    display: flex;
    margin-bottom: 8px;
    line-height: 1.5;

    &:last-child {
      margin-bottom: 0;
    }

    .label {
      color: #606266;
      white-space: nowrap;
      font-weight: 500;
      width: 130px;
      flex-shrink: 0;
    }

    .value {
      color: #303133;
      word-break: break-all;
    }
  }
}
</style>
